// extracted by mini-css-extract-plugin
export default {"backdrop":"Modal_backdrop__o2vvV","modal":"Modal_modal__8kqbE","slide-down":"Modal_slide-down__0IAtB"};